/* globals angular, _ */
(function () {
  'use strict';

  function UpdateTermsCtrl (
    $uibModal,
    $stateParams,
    Perfil,
    Pedido,
    TermsService,
    Cep
  ) {
    var ctrl = this;

    ctrl.onSubmit = function (form) {
      if (form.$invalid) { return; }
      ctrl.isBtnLoading = true;
      var user = $stateParams.user || Perfil.getCacheUserData();

      TermsService
        .accept_update({userId: user.id}, {aceiteAtualizacaoTermoContrato: true})
        .$promise
        .then(function () {
          Pedido.redirecionar();
        })
        .catch(function (error) {
          console.log(error.statusText);
        });
    };
  }

  angular
    .module('mandaeApp')
    .controller('UpdateTermsCtrl', UpdateTermsCtrl);
}());
